export const DATE_TIME_FORMAT = {
  GENERAL: 'DD/MM/YYYY (hh:mmA)',
  NORMAL_DATE: 'DD/MM/YYYY',
};
